import { OperationCode } from './types';

export const DEFAULT_OPERATION_CODES: OperationCode[] = [
  'serraria',
  'industria',
  'gestao',
  'logistica',
];

export const operationLabels: Record<OperationCode, string> = {
  serraria: 'Serraria',
  industria: 'Industria',
  gestao: 'Gestao',
  logistica: 'Logistica',
};
